import { fleetApi } from 'api/axiosClient';
import { timezone } from '../utils/timeZone';

export const apiOslogCrud = (resource, api = fleetApi, overrides = {}) => {
  const defaultCrud = {
    create: (data) => api.post(`${resource}/new`, data),
    update: (id, data) => api.put(`${resource}/edit/${id}`, data),
    remove: (id) => api.delete(`${resource}/delete/${id}`),
    getById: (id) => api.get(`${resource}/${id}`),
    search: (payload, withTimezone = true, query = {}) => {
      const params = withTimezone ? { tz: timezone, ...query } : Object.keys(query).length > 0 ? query : undefined;

      return api.post(`${resource}/search`, payload, { params });
    }
  };

  return { ...defaultCrud, ...overrides };
};
